import httpService from "./httpService.js"

// Customers
export const getAllCustomersService = (page, limit, q) => {
    return httpService(`/admin_accounts/customer_admin_panel/?page=${page}&limit=${limit}${q ? `&q=${q}` : ""}`, "get");
}

export const getSingleCustomerService = (userId) => {
    return httpService(`/admin_accounts/user_view/${userId}/`, "get");
}

export const getServicesOfAnCustomerService = (userId) => {
    return httpService(`/admin_accounts/customer_admin_panel/${userId}`, "get");
}

export const editCustomerService = (userId, data) => {
    return httpService(`/admin_accounts/customer_admin_panel/${userId}/`, "patch", data);
}

// Admins
export const getAllAdminsService = () => {
    return httpService("/admin_accounts/admin_view/", "get");
}

export const getInventory = () => {
    return httpService("/admin_accounts/get_inventory/", "get");
}

export const getContractorListService = (service_code) => {
    return httpService(`/admin_accounts/contractor_list/${service_code}/`, "get");
}

export const getContractorDetailsService = (contractor_id) => {
    return httpService(`/admin_accounts/contractor_detail/${contractor_id}/`, "get");
}

export const contractorAssignmentService = (service_code, data) => {
    return httpService(`/admin_accounts/contractor_assingment/${service_code}/`, "post", data);
}

export const withdrawalRequest = (data) => {
    return httpService("/admin_accounts/withdrawal_request/", "post", data);
}

export const withdrawalRequestList = (page, limit, q, status) => {
    return httpService(`/admin_accounts/withdrawal_request/?page=${page}&limit=${limit}&status=${status}${q ? `&q=${q}` : ""}`, "get");
}

export const uploadReceipt = (transactionId, data) => {
    return httpService(`/admin_accounts/upload_receipt/${transactionId}/`, "patch", data, "multipart/form-data");
}

export const accountSettlementService = (service_code) => {
    return httpService(`/admin_accounts/account_settlement/${service_code}/`, "patch");
}

export const getSingleAdminService = (adminId) => {
    return httpService(`/admin_accounts/admin_view/${adminId}/`, "get");
}

export const addNewAdminService = (data) => {
    return httpService("/admin_accounts/admin_view/", "post", data);
}

export const editAdminService = (adminId, data) => {
    return httpService(`/admin_accounts/admin_view/${adminId}/`, "patch", data);
}

export const deleteAdminService = (adminId) => {
    return httpService(`/admin_accounts/admin_view/${adminId}/`, "delete");
}

export const changePasswordAdminService = (data) => {
    return httpService("/admin_accounts/admin_change_password/", "put", data);
}

export const changeRoleToAdmin = (userId) => {
    return httpService(`/admin_accounts/admin_change_role/${userId}/`, "patch");
}